import { DiscoveryApi, IdentityApi } from '@backstage/core-plugin-api';
import { GitlabRegistryApi } from './api.interface';
import { GitlabRegistryRepositoryDetail } from './dto/response/gitlab-registry-repository-detail';
import CustomError from '../../components/shared/error-handling/error';
import { GitlabRegistryRepository } from './dto/response/gitlab-registry-repository';
import { GitlabTagDetail } from './dto/response/gitlab-registry-tag-detail';

const PROJECT_ID = '668';

export class GitlabRegistryClient implements GitlabRegistryApi {

  constructor(private readonly discoveryApi: DiscoveryApi, private readonly identityApi: IdentityApi) { }


  private async fetch<T = any>(input: string, init?: RequestInit): Promise<T> {
    // As configured previously for the backend proxy
    const proxyUri = `${await this.discoveryApi.getBaseUrl('proxy')}/gitlab`;

    const token = (await this.identityApi.getCredentials()).token;
    const headers = {
      ...init?.headers,
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    // Create a new init object with merged headers
    const newInit: RequestInit = {
      ...init,
      headers: headers
    };

    const resp = await fetch(`${proxyUri}${input}`, newInit);
    if (!resp.ok) {
      throw new CustomError(`Error ${resp.status}: ${resp.statusText}`, resp.status);
    }
    return await resp.json();
  }


  async listRepositories(page: number, perPage: number) {
    const proxyUri = `${await this.discoveryApi.getBaseUrl('proxy')}/gitlab`;
    const token = (await this.identityApi.getCredentials()).token;
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    const newInit: RequestInit = {
      headers: headers
    };

    const resp = await fetch(`${proxyUri}/projects/${PROJECT_ID}/registry/repositories?page=${page}&per_page=${perPage}`, newInit);
    if (!resp.ok) {
      throw new CustomError(`Error ${resp.status}: ${resp.statusText}`, resp.status);
    }

    const repos: GitlabRegistryRepository[] = await resp.json();
    const total = parseInt(resp.headers.get('x-total') || '0', 10);
    const totalPages = parseInt(resp.headers.get('x-total-pages') || '0', 10);

    return { repos, total, totalPages };
  }

  async getRepository(repositoryId: number) {
    const repository: GitlabRegistryRepositoryDetail = await this.fetch(
      `/registry/repositories/${repositoryId}?tags=true&tags_count=true&size=true`
    );
    return { repository };
  }

  async getTag(repositoryId: number, tagName: string) {

    const tag: GitlabTagDetail = await this.fetch(
      `/projects/${PROJECT_ID}/registry/repositories/${repositoryId}/tags/${tagName}`
    );

    return { tag };
  }
}
